import styled from 'styled-components'
import { baseTheme } from 'primsell-shared-layer/styles/theme'
import { StyledTypography } from '../typography/typography.styles'

export const StyledTextAreaWrapper = styled.div`
  color: ${({ theme }) => theme.text.primary};
  width: 100%;
  max-width: 400px;

  & > p {
    color: ${({ theme }) => theme.error.main};
    margin-left: 2px;
  }
`
export const StyledTextAreaLabel = styled.label`
  display: flex;
  position: relative;

  svg {
    position: absolute;
    top: 50%;
    right: 15px;
    transform: translateY(-50%);
  }

  div {
    cursor: pointer;
  }
`

export const StyledTextArea = styled.textarea<{ autoResize?: boolean; error?: boolean; disabled?: boolean }>`
  width: 100%;
  background: ${({ theme }) => theme.background.grey};
  border-radius: 8px;
  color: ${baseTheme.colors.lightDark};
  padding: 10px 8px;
  border: 1px solid ${({ theme, error }) => (error ? theme.border.error : theme.border.default)};
  font-size: ${baseTheme.typography.fontSize.md};
  line-height: 20px;
  transition: 0.3s;
  transition-property: border;
  resize: none;
  overflow-y: ${({ autoResize }) => (autoResize ? 'hidden' : 'auto')};
  font-family: 'Inter', sans-serif;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  scrollbar-width: none;
  -ms-overflow-style: none;

  &:disabled {
    &:hover {
      border: 1px solid ${({ theme }) => theme.border.default};
    }
    color: #9a9b9c;
  }

  &:hover {
    border: 1px solid ${({ theme, error }) => (error ? theme.border.error : theme.border.hover)};
  }

  &:focus-within {
    border: 1px solid ${({ theme, error }) => (error ? theme.border.error : theme.border.focus)};
  }
  &:focus-visible {
    outline: none;
  }
  &::placeholder {
    color: ${({ theme }) => theme.text.placeholder};
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    font-family: 'Inter', sans-serif;
  }

  &::-webkit-scrollbar {
    width: 8px;
    margin-right: 4px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    padding: 12px;
    margin: 12px;

    background-color: #c0c0c0;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    margin-top: 4px;
    margin-bottom: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${baseTheme.colors.grey3};
  }

  &::-webkit-scrollbar-thumb:active {
    background-color: ${baseTheme.colors.darkGrey};
  }
`

interface IStyledTextAreaErrorProps {
  isExceed?: boolean
}
export const StyledMaxLength = styled.div<IStyledTextAreaErrorProps>`
  ${StyledTypography} {
    color: ${({ theme, isExceed }) => (isExceed ? `${theme.error.main}` : theme.text.placeholder)};
  }
`
